<template>
    <hts-popover
        v-model="show"
        max-width="805"
        placement="bottom-end">
        <template #reference>
            <button
                class="relative mr-6 mt-2"
                type="button">
                <hi-exclamation-triangle-icon class="text-main-text dark:text-main-text-dark text-zinc-800 w-7 h-7" />
            </button>
        </template>
        <div
            v-loading="loading"
            class="py-2">
            <div
                v-if="hasAlert"
                class="mb-4 space-y-2 max-h-[360px] max-w-[460px] pr-1 overflow-auto"
                @scroll="handleScroll">
                <template
                    v-for="(item, index) in alerts"
                    :key="index">
                    <alert-item
                        :item="item"
                        :item-index="index"
                        @read="handleRead" />
                </template>
            </div>
            <div v-else>
                <p class="px-2">
                    Hiện tại chưa có cảnh báo.
                </p>
            </div>
        </div>
    </hts-popover>
</template>
<script lang="ts" setup>
import AlertItem from './alert-item.vue'

const store = $store()
const loading = ref(true)
const show = ref(false)
const alerts = ref<any[]>([])
const hasAlert = computed(() => Array.isArray(alerts.value) && alerts.value.length > 0)
const alertLength = computed(() => alerts.value.length)
const loadedAll = ref(false)
const companyType = computed(() => store.auth.companyType)
const api = computed(() => {
  return $url.utils.journeyAlerts
})

const getAlerts = () => {
  if (loadedAll.value) {
    return
  }
  $api(api.value, { query: { skip: alertLength.value } }).then(({ data }: any) => {
    const tmpAlerts: any[] = (data?.value || {}).data || []
    if (Array.isArray(tmpAlerts) && tmpAlerts.length) {
      alerts.value = alerts.value.concat(tmpAlerts)
    } else {
      loadedAll.value = true
    }
  })
}
onMounted(() => {
  loading.value = true
  alerts.value = []
  getAlerts()
  nextTick(() => {
    loading.value = false
  })
})
const loadMore = $lodash.debounce(() => {
  getAlerts()
}, 300)

const handleScroll = (e: any) => {
  const { target } = e
  if (target.scrollTop + target.offsetHeight > target.scrollHeight - 300) {
    loadMore()
  }
}
const handleRead = () => {}
</script>
